<template>
  <div class="space-y-6">
    <div class="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <div class="text-sm font-semibold text-slate-700">Live status</div>
        <h2 class="mt-1 text-2xl font-bold tracking-tight text-slate-900">Active vehicles</h2>
      </div>
      <div class="rounded-lg bg-white px-3 py-2 text-xs text-slate-600 ring-1 ring-slate-200">
        Inside now: <span class="font-semibold text-slate-900">{{ active.length }}</span>
      </div>
    </div>

    <div class="rounded-2xl bg-white p-4 ring-1 ring-slate-200">
      <input
        v-model.trim="q"
        placeholder="Search plate…"
        class="w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-mono outline-none ring-sky-200 focus:ring-4 sm:max-w-sm"
      />

      <div class="mt-4 overflow-x-auto rounded-xl ring-1 ring-slate-200">
        <table class="w-full min-w-[560px] text-left text-xs">
          <thead class="bg-slate-50 text-slate-600">
            <tr>
              <th class="px-3 py-2 font-semibold">Plate</th>
              <th class="px-3 py-2 font-semibold">Type</th>
              <th class="px-3 py-2 font-semibold">Entry time</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="s in filtered" :key="s.id" class="border-t border-slate-200">
              <td class="px-3 py-2 font-mono font-semibold text-slate-900">{{ s.plateNumber }}</td>
              <td class="px-3 py-2">
                <span class="rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1"
                  :class="s.type === 'permanent' ? 'bg-emerald-50 text-emerald-700 ring-emerald-200' : 'bg-sky-50 text-sky-700 ring-sky-200'">
                  {{ s.type }}
                </span>
              </td>
              <td class="px-3 py-2 text-slate-600">{{ dt(s.entryTime) }}</td>
            </tr>
            <tr v-if="filtered.length === 0">
              <td class="px-3 py-8 text-center text-slate-500" colspan="3">No active vehicles.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();
const q = ref("");
const active = computed(() => store.getters.activeSessions);

const filtered = computed(() => {
  const query = q.value.toUpperCase();
  if (!query) return active.value;
  return active.value.filter((s) => String(s.plateNumber || "").includes(query));
});

function dt(iso) {
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}
</script>

